import { createRoute } from '@tanstack/react-router';
import { Route as rootRoute } from './__root';
import { Helmet } from 'react-helmet-async';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/privacy',
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <div className="flex flex-col min-h-screen bg-white dark:bg-neutral-950">
      <Helmet>
        <title>Privacy Policy - Cardston Market</title>
        <meta name="description" content="Learn how Cardston Market collects, uses, and protects your personal information. We are committed to transparency and your privacy." />
        <link rel="canonical" href="https://www.cardstonmarket.com/privacy" />
        <meta property="og:title" content="Privacy Policy - Cardston Market" />
        <meta property="og:description" content="Learn how Cardston Market collects, uses, and protects your personal information." />
        <meta property="og:url" content="https://www.cardstonmarket.com/privacy" />
        <meta name="twitter:card" content="summary" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Privacy Policy",
          "description": "Privacy Policy for Cardston Market marketplace.",
          "url": "https://www.cardstonmarket.com/privacy",
          "isPartOf": { "@id": "https://www.cardstonmarket.com/#website" },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.cardstonmarket.com/" },
              { "@type": "ListItem", "position": 2, "name": "Privacy Policy", "item": "https://www.cardstonmarket.com/privacy" }
            ]
          }
        })}</script>
      </Helmet>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">
        <h1 className="text-4xl font-serif font-medium text-neutral-900 dark:text-white mb-8 tracking-tight">Privacy Policy</h1>
        
        <div className="prose prose-neutral dark:prose-invert max-w-none text-neutral-600 dark:text-neutral-400 font-light leading-relaxed space-y-8">
          <p className="text-lg text-neutral-900 dark:text-neutral-200">Last Updated: April 2026</p>

          <section>
            <h2 className="text-2xl font-serif font-medium text-neutral-900 dark:text-white mt-12 mb-4">1. Information We Collect</h2>
            <p>
              We collect information you provide directly to us when creating an account, such as your email address and name. We also collect transaction information when you make purchases.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-medium text-neutral-900 dark:text-white mt-12 mb-4">2. How We Use Information</h2>
            <p>
              We use the information we collect to operate our platform, process transactions, communicate with you, and improve our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-medium text-neutral-900 dark:text-white mt-12 mb-4">3. Information Sharing</h2>
            <p>
              We share necessary information with vendors to fulfill your orders. We do not sell your personal data to third parties.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
